import React from "react";
import copyToClipboard from "@/utils/copyToClipboard";
import { Alert } from "aha-components";
import { useOrganization } from "@clerk/clerk-react";
import { message } from "antd";
import { CopyIcon } from "../icons";
import { useTranslation } from "react-i18next";

export default function BankTransfer() {
  const { organization } = useOrganization();
  const { t } = useTranslation();

  const airwallexItems = [
    {
      label: t("components.chargeModal.accountName"),
      value: "Aha Inc.",
    },
    {
      label: t("components.chargeModal.bankAccountNumber"),
      value: "8487983770",
    },
    {
      label: t("components.chargeModal.achRoutingNumber"),
      value: "026073150",
    },
    {
      label: t("components.chargeModal.fedwireRoutingNumber"),
      value: "026073008",
    },
    {
      label: t("components.chargeModal.swiftCode"),
      value: "CMFGUS33",
    },
    {
      label: t("components.chargeModal.bankName"),
      value: "Community Federal Savings Bank",
    },
    {
      label: t("components.chargeModal.accountLocation"),
      value: "United States of America",
    },
    {
      label: t("components.chargeModal.companyAddress"),
      value: "257 OLD CHURCHMANS RD NEW CASTLE, DE 19720",
    },
    {
      label: t("components.chargeModal.bankAddress"),
      value: "89-16 Jamaica Ave, Woodhaven NY USA",
    },
  ];

  const chaseItems = [
    {
      label: t("components.chargeModal.accountName"),
      value: "AHALAB.AI INC.",
    },
    {
      label: t("components.chargeModal.accountNo"),
      value: "602565809",
    },
    {
      label: t("components.chargeModal.abaRouting"),
      value: "021000021",
    },
    {
      label: t("components.chargeModal.swiftCodeCapitalized"),
      value: "CHASUS33",
    },
    {
      label: t("components.chargeModal.bankAddressCapitalized"),
      value: "39-01 Main St Flushing NY 11354",
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <Alert
        type="info"
        description={
          <div className="self-stretch justify-start">
            <span className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-5">
              {t("components.chargeModal.pleaseAddWorkSpace")}{" "}
            </span>
            <span className="text-font&icon-primary text-sm font-bold font-['DM_Sans'] underline leading-5">
              {organization?.name}{" "}
            </span>
            <span className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-5">
              {t("components.chargeModal.workSpaceName")}{" "}
              {t("components.chargeModal.toTheNotes")}
            </span>
          </div>
        }
      />
      <div className="border border-[#E5E5E5] rounded-[8px] p-[18px]">
        <div className="flex justify-between items-center">
          <div className="justify-center text-black text-base font-semibold font-['DM_Sans'] leading-6">
            Airwallex
          </div>
          <div
            className="px-3 py-1.5 rounded-md border border-divider flex justify-start items-center gap-1.5 cursor-pointer"
            onClick={() => {
              const allContent = airwallexItems
                .map((item) => `${item.label} ${item.value}`)
                .join("\n");
              copyToClipboard(allContent);
              message.success(t("components.chargeModal.copied"));
            }}
          >
            <CopyIcon className="w-4 h-4 text-[#8B8D98]" />
            <div className="justify-center text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
              {t("components.chargeModal.copyAll")}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 mt-3">
          {airwallexItems.map((item) => (
            <div className="flex items-center gap-3" key={item.label}>
              <div className="w-[140px] text-right justify-center text-font&icon-secondary text-xs font-normal font-['DM_Sans']">
                {item.label}
              </div>
              <div
                className="justify-center text-font&icon-primary text-sm font-semibold font-['DM_Sans'] leading-5 flex items-center gap-[3px] cursor-pointer"
                onClick={() => {
                  copyToClipboard(item.value);
                  message.success(t("components.chargeModal.copied"));
                }}
              >
                {item.value}
                <CopyIcon className="w-4 h-4 text-[#A6A09B]" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="border border-[#E5E5E5] rounded-[8px] p-[18px]">
        <div className="flex justify-between items-center">
          <div className="justify-center text-black text-base font-semibold font-['DM_Sans'] leading-6">
            Chase
          </div>
          <div
            className="px-3 py-1.5 rounded-md border border-divider flex justify-start items-center gap-1.5 cursor-pointer"
            onClick={() => {
              const allContent = chaseItems
                .map((item) => `${item.label} ${item.value}`)
                .join("\n");
              copyToClipboard(allContent);
              message.success(t("components.chargeModal.copied"));
            }}
          >
            <CopyIcon className="w-4 h-4 text-[#8B8D98]" />
            <div className="justify-center text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
              {t("components.chargeModal.copyAll")}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3 mt-3">
          {chaseItems.map((item) => (
            <div className="flex items-center gap-3" key={item.label}>
              <div className="w-[140px] text-right justify-center text-font&icon-secondary text-xs font-normal font-['DM_Sans']">
                {item.label}
              </div>
              <div
                className="justify-center text-font&icon-primary text-sm font-semibold font-['DM_Sans'] leading-5 flex items-center gap-[3px] cursor-pointer"
                onClick={() => {
                  copyToClipboard(item.value);
                  message.success(t("components.chargeModal.copied"));
                }}
              >
                {item.value}
                <CopyIcon className="w-4 h-4 text-[#A6A09B]" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="self-stretch justify-center text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-5">
        {t("components.chargeModal.estimatedArrivalTimesMessage")}
      </div>
    </div>
  );
}
